import {fetchWithTimeout, checkPermission, TIMEOUT, PERMISSION_ADMIN, PERMISSION_OPERATOR, PERMISSION_MONITORING} from './api_common';
import {getCookie, getFetchError, getCatchError} from '../app_common.js';

export const getApiAlertCodes = async() => {
    if( !checkPermission('getApiAlertCodes', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/codes`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiAlertStatus = async(perPage, curPage, filter, sortTitle, sortOrder) => {
    if( !checkPermission('getApiAlertStatus', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/status?per_page=${perPage}&page=${curPage}${filter.length>0?'&filter='+filter:''}${sortTitle.length>0?'&sort_title='+sortTitle:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiAlertStatus = async() => {
    if( !checkPermission('delApiAlertStatus', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/status/`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiAlertResolved = async() => {
    if( !checkPermission('delApiAlertResolved', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/resolved`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiAlertStatusCount = async(filter) => {
    if( !checkPermission('getApiAlertStatusCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/status-count${filter.length>0?'?filter='+filter:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiAlertStatusFingerprint = async(fingerPrint) => {
    if( !checkPermission('delApiAlertStatusFingerprint', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/status/${fingerPrint}`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiAlertRules = async(pagePer, pageCur, sortTitle, sortOrder) => {
    if( !checkPermission('getApiAlertRules', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/rules?per_page=${pagePer}&page=${pageCur}${sortTitle.length>0?'&sort_title='+sortTitle:''}${sortOrder.length>0?'&sort_order='+sortOrder:''}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const postApiAlertRules = async(sendData) => {
    if( !checkPermission('postApiAlertRules', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/rules`, {
            timeout: TIMEOUT,
            method: 'POST',
            headers: {
                "accept": "application/json",
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiAlertRulesCount = async() => {
    if( !checkPermission('getApiAlertRulesCount', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/rules-count`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const getApiAlertRulesId = async(id) => {
    if( !checkPermission('getApiAlertRulesId', PERMISSION_MONITORING) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/rules/${id}`, {
            timeout: TIMEOUT,
            method: 'GET',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, false);
            return json;
        } catch (e) {
            getFetchError(response, null, false);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const putApiAlertRulesId = async(sendData, id) => {
    if( !checkPermission('putApiAlertRulesId', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/rules/${id}`, {
            timeout: TIMEOUT,
            method: 'PUT',
            headers: {
                "accept": "application/json",
                "Content-type": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
            body: JSON.stringify(sendData),
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}

export const delApiAlertRulesId = async(id) => {
    if( !checkPermission('delApiAlertRulesId', PERMISSION_OPERATOR) )
    { 
        return null;
    }

    try {
        const response = await fetchWithTimeout(`/api/alert/rules/${id}`, {
            timeout: TIMEOUT,
            method: 'DELETE',
            headers: {
                "accept": "application/json",
                "Authorization": "Bearer " + getCookie('accessToken')
            },
        });

        try {
            const json = await response.json();
            getFetchError(response, json, true);
            return json;
        } catch (e) {
            getFetchError(response, null, true);
            return null;
        }
    } catch (err) {
        getCatchError(err);
        return null;
    };
}